<template>
  <div :class="['box', { right: facingRight }]">
    <p class="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "MessageBox",
  props: {
    message: {
      required: true,
      type: String,
    },
    facingRight: {
      type: Boolean,
      default: false,
    },
    top: {
      type: String,
      default: "28.261%",
    },
    left: {
      type: String,
      default: "29.378%",
    },
    right: {
      type: String,
      default: "27.261%",
    },
  },
};
</script>

<style scoped>
.box {
  position: relative;
  height: fit-content;
  width: fit-content;
  max-width: 260px;
  padding: 1rem 2rem;
  background: #f4f7fa;
  z-index: 1;
  border-radius: 10px;
  top: v-bind(top);
  left: v-bind(left);
  right: v-bind(right);
}

.message {
  line-height: 1.2rem;
  text-align: center;
}

.box::before {
  content: "";
  position: absolute;
  bottom: -1.7rem;
  left: -0.8rem;
  width: 60px;
  height: 70px;
  clip-path: polygon(50% 0%, 18% 100%, 88% 100%);
  transform: rotate(-120deg);
  z-index: -1;
  background: inherit;
}

.box.right::before {
  transform: rotate(120deg);
  left: initial;
  right: -0.8rem;
}

@media screen and (max-width: 720px) {
  .box {
    left: 2%;
  }
}

@media screen and (max-width: 490px) {
  .box {
    padding: 0.5rem 1rem;
  }

  .message {
    font-size: 0.9rem;
  }
}
</style>
